import { render, staticRenderFns } from "./PrenatalTargetedExome.vue?vue&type=template&id=48b0ffd2"
import script from "./PrenatalTargetedExome.vue?vue&type=script&lang=js"
export * from "./PrenatalTargetedExome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports